export default __webpack_public_path__ + "static/agency-about-img-f800839a9817b5c6d8b4c11eb09b4822.jpg";